<template>
    <div class="_contact active" v-if="shop">
        <h3 class="contact-us__title">Контакты</h3>

        <div class="contact-item">
            <span class="_icon">
                <img
                    src="/assets/img/automatize/icons/contact-location.svg"
                    alt=""
                />
            </span>
            <span class="_content">
                <span class="_title" v-html="shop.address"></span>
                <span>Главный офис, производство</span>
            </span>
        </div>

        <a class="contact-item" :href="`tel:${shop.telephone}`">
            <span class="_icon">
                <img
                    src="/assets/img/automatize/icons/contact-phone.svg"
                    alt=""
                />
            </span>
            <span class="_content">
                <span class="_title">{{ shop.telephone }}</span>
                <span>Единая линия: 10:00-20:00</span>
            </span>
        </a>

        <a class="contact-item" :href="`mailto:${shop.email}`">
            <span class="_icon">
                <img
                    src="/assets/img/automatize/icons/contact-mail.svg"
                    alt=""
                />
            </span>
            <span class="_title">{{ shop.email }}</span>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        shop: {
            type: Object || null,
            default: null,
        },
    },
};
</script>
